import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController, LoadingController, AlertController, ModalController, ToastController, FabContainer, App } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { AuthProvider } from '../../providers/auth/auth';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/mergeMap';

import { PatientAddPage } from '../patient-add/patient-add';
import { FirestoreProvider } from '../../providers/firestore/firestore';
import { SurveyPage } from '../survey/survey';
import { DatabaseProvider, medication } from '../../providers/database/database';
import { PatientMedicationPage } from '../patient-medication/patient-medication';

@IonicPage()
@Component({
    selector: 'page-home',
    templateUrl: 'home.html',
})
export class HomePage {
    message: string;
    toastBackground: string = null;
    clinic_name: string = null;
    clinic_id: string = null;
    public studyList: Observable<any[]>;
    public prescriptionList: Observable<any[]>;
    public patientStudy: Observable<any[]>;
    studyinfo: any;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public popoverCtrl: PopoverController,
        public loadingCtrl: LoadingController,
        public modalCtrl: ModalController,
        public alertCtrl: AlertController,
        public toastCtrl: ToastController,
        private readonly auth: AuthProvider,
        public database: DatabaseProvider,
        private storage: Storage,
        public firestoreProvider: FirestoreProvider
    ) { 
      this.auth.getCurrentUser().then(user => {
        this.clinic_name = user.clinic_name;
        this.clinic_id =  user.clinic_id;

        this.studyList = this.database
        .getStudiesByClinicFollowUp(this.clinic_id)
        .snapshotChanges().map(actions => {       
            return actions.map(a => {
              const data = a.payload.doc.data() as any;
              data.id = a.payload.doc.id;
              return data;
            });
          });

          this.prescriptionList = this.database
          .getPrescriptionsByClinicFollowUp(this.clinic_id)
          .snapshotChanges().map(actions => {       
              return actions.map(a => {
                const data = a.payload.doc.data() as any;
                data.id = a.payload.doc.id;
                return data;
              });
            });
      })

    }

    ionViewDidLoad() {}

    ionViewWillEnter() {}

    goPatient() {
        this.navCtrl.push(PatientAddPage);
    }

    onStorageUrlEmitted(ev) {
      console.log(ev)
    }
    

  public getColor(date, interval) {
    let myMoment: moment.Moment
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    myMoment = myMoment.add(interval, "M");
    let todayMoment: moment.Moment = moment();
    if (todayMoment.isAfter(myMoment)) {
      return { background: "red", color: "white", width: "110px" };
    } else {
      return null;
    }
  }

  public getFollowup(date, interval) {
    let myMoment: moment.Moment
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    myMoment = myMoment.add(interval, "M");
    return myMoment.format("YYYY MMM DD");
  }

  public isFollowUp(date, interval) {
    let myMoment: moment.Moment
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    myMoment = myMoment.add(interval, "M");
    let todayMoment: moment.Moment = moment();
    if (todayMoment.isAfter(myMoment)) {

      return true
    } else {
      return false;
    }
  }

  public formatDate(date) {
    let myMoment: moment.Moment
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format("YYYY MMM DD");
  }

  addPrescription(prescription) {

    
    this.patientStudy = this.database.getStudiesByPatient(this.clinic_id, prescription.patient_id).valueChanges();
    this.patientStudy.subscribe((data) => {
      prescription.patient['study'] = {};
      prescription.patient.study['completed'] = false;
      prescription.patient.study['name'] = null;
      prescription.patient.study.updatedAt = null;
      if(data.length > 0)  {
        console.log(data)
        prescription.patient.study.completed = true;
        prescription.patient.study.name = data[0].study[0].name;
        if(data[0].udpatedAt) prescription.patient.study.updatedAt = data[0].udpatedAt.toDate();
        else prescription.patient.study.updatedAt = data[0].updatedAt.toDate();
        console.log(prescription.patient)
      }
      else {
        prescription.patient.study.completed = false;
        prescription.patient.study.name = null;
        prescription.patient.study.updatedAt = null;
      }

      let patientdata = {
        prescription_id: prescription.id,
        patient: prescription.patient,
        doctor: prescription.doctor,
        existingpatient: true
      };
      this.navCtrl.push(PatientMedicationPage, patientdata);
    })
  }

 

  public completeFollowUp(study: object, isfollowup: boolean): void {
    if(isfollowup)  {
      let confirm = this.alertCtrl.create({
        title: "Complete Follow-up",
        message: "A study follow-up is necessary for " + study['patient'].first_name + " " + study['patient'].last_name + ".  Would you like to complete one now?",
        buttons: [
          {
            text: "No",
            handler: () => {
              console.log("Don't save study");
            }
          },
          {
            text: "Yes",
            handler: () => {
                this.studyinfo = study;
                console.log(study['id'])

                  
                  let studydata = {
                    clinic: study['clinic'],
                    patient: study['patient'],
                    doctor: study['doctor'],
                    medication: study['medication'],
                    study: study['study'],
                    agreement: study['agreement'],
                    renewal: true,

                    laststudyid: study['id']
                  };
              
                  let studyModal = this.modalCtrl.create(SurveyPage, studydata, {cssClass: 'select-modal' });
                  studyModal.onDidDismiss(data => {
                    if(data)  {
                      study['isComplete'] = true;
                    }
                    else {
                      study['isComplete'] = false;
                    }
                    
                  });
                  studyModal.present();
              /*
              const toast = this.toastCtrl.create({
                message: 'Follow-up of studies is currently not available.  This feature will be enabled in a future version.',
                duration: 3000
              });
              toast.present();
              */
            }
          }
        ]
      });
      confirm.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts